import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29367964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "safety-tags-wrap" }
const _hoisted_2 = { class: "total-count" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_CmTag = _resolveComponent("CmTag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagSHow.slice(0, _ctx.max), (item, index) => {
      return (_openBlock(), _createBlock(_component_CmTag, {
        key: index,
        "bg-color": item.bgColor,
        color: item.color,
        border: false
      }, {
        default: _withCtx(() => [
          (item.icon)
            ? (_openBlock(), _createBlock(_component_CmSvgIcon, {
                key: 0,
                name: item.icon,
                size: 14,
                monochrome: "",
                class: "cm-ui-mr5"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(item.title), 1)
        ]),
        _: 2
      }, 1032, ["bg-color", "color"]))
    }), 128)),
    (_ctx.tagSHow.length > _ctx.max)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: _ctx.geTooltipContent(),
          "open-delay": 300
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, "…共" + _toDisplayString(_ctx.tagSHow.length) + "个", 1)
          ]),
          _: 1
        }, 8, ["content"]))
      : _createCommentVNode("", true),
    (!_ctx.tagSHow.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.empty), 1))
      : _createCommentVNode("", true)
  ]))
}